<template>
<section class="youtube-video px-4 py-4" :class="shift_up ? 'shift-up vt:py-0' : 'py-5%'">
    <SmoothLoader class="max-w-4xl preview-container mx-auto relative z-20">

        <VideoModal :youtube-id="youtube_id" class="preview bg-expands bg-primary-800 rounded-lg overflow-hidden relative flex items-center justify-center hover:bg-secondary-600 focus:bg-secondary-600 transition-colors icon-expands">

            <BackgroundImage :src="preview_image.src" :alt="preview_image.alt" opacity="0.6"></BackgroundImage>
            <div class="relative z-10">
                <i aria-hidden="true" class="fa-solid fa-circle-play text-white"></i>
                <span class="sr-only">Play Video</span>
            </div>

        </VideoModal>

    </SmoothLoader>
</section>
</template>

<script>
import VideoModal from '../Utilities/VideoModal.vue';

export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    },
    components: {
        VideoModal
    }
}
</script>